module.exports = __webpack_public_path__ + "static/media/codechef_logo2.63b7b710.jpg";